import React from 'react'
import { useParams } from 'react-router-dom'

import { useQuery } from '@tanstack/react-query'

import api from 'services/api'

import { useUser } from 'contexts/user.context'

import * as S from './style'

interface RankingProps {
  itinerariesLength?: number
}

type TravelerTier = {
  minPoints: number
  name: string
}

const TRAVELER_TIERS: TravelerTier[] = [
  { minPoints: 0, name: 'Passageiro de Primeira Viagem' },
  { minPoints: 50, name: 'Mochileiro' },
  { minPoints: 150, name: 'Explorador' },
  { minPoints: 300, name: 'Desbravador' },
  { minPoints: 500, name: 'Viajante Nato' }
]

const RankingIcon: React.FC<RankingProps> = ({ itinerariesLength = 0 }) => {
  const params = useParams<{ id?: string }>()
  const { user } = useUser()
  const targetUserId = params.id ?? user?.id

  const { data: followers = [] } = useQuery({
    queryKey: ['rankingFollowers', targetUserId],
    queryFn: async () => {
      const response = await api.get(`/user-follower/followers/${targetUserId}`)
      return response.data
    },
    enabled: !!targetUserId,
    staleTime: 60 * 1000
  })

  const followersLength = Array.isArray(followers) ? followers.length : 0
  const points = itinerariesLength * 10 + followersLength * 2
  const currentTier =
    [...TRAVELER_TIERS].reverse().find((tier) => points >= tier.minPoints) ??
    TRAVELER_TIERS[0]
  const currentIndex = TRAVELER_TIERS.findIndex(
    (tier) => tier.name === currentTier.name
  )
  const nextTier = TRAVELER_TIERS[currentIndex + 1]
  const pointsToNextTier = nextTier ? nextTier.minPoints - points : 0

  const tooltip = nextTier
    ? `${points} pontos. Faltam ${pointsToNextTier} ${
        pointsToNextTier === 1 ? 'ponto' : 'pontos'
      } para atingir o próximo nível. Crie novos roteiros e conquiste mais seguidores para aumentar sua pontuação.`
    : `${points} pontos. Você atingiu o nível máximo. Continue criando roteiros e conquistando seguidores para aumentar sua pontuação.`

  return (
    <S.Wrapper title={tooltip} aria-label={tooltip}>
      {currentTier.name}
    </S.Wrapper>
  )
}

export default RankingIcon
